import DateFnsUtils from "@date-io/date-fns/build";
import { Button, Checkbox, FormControlLabel, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment/moment";
import React, { useState } from 'react';
import NumberFormat from "react-number-format";
import useStyles from "src/Styles";

const CreateScheduleComponent = (props) => {

    const classes = useStyles();
    const [isMultiDaySchedule, setIsMultiDaySchedule] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [schedules, setSchedules] = useState([]);

    const handleMultiDayScheduleChange = () => {
        setIsMultiDaySchedule(!isMultiDaySchedule);
    }

    const startDateChangeHandler = (date) => {
        setStartDate(date);
    }

    const endDateChangeHandler = (date) => {
        setEndDate(date);
    }

    const handleHourValueChange = (e, hourBeginning) => {
        let index = -1;
        for (let i = 0; i < schedules.length; i++) {
            if (schedules[i].hourBeginningDateTime.hourBeginning === hourBeginning) {
                index = i;
            }
        }
        if (index === -1) {
            schedules.push(
                {
                    hourBeginningDateTime: {
                        hourBeginning: hourBeginning
                    },
                    segmentValue: e.value
                }
            )
        } else {
            schedules[index].segmentValue = e.value;
        }
        setSchedules([...schedules]);
    }

    const findHourValue = (hourBeginning) => {
        let index = -1;
        for (let i = 0; i < schedules.length; i++) {
            if (schedules[i].hourBeginningDateTime.hourBeginning === hourBeginning) {
                return schedules[i].segmentValue;
            }
        }
        return 0;
    }

    const renderTableRows = () => {
        let rows = [];
        for (let i = 0; i < 24; i++) {
            rows.push((
                <TableRow key={i}>
                    <TableCell>{i}</TableCell>
                    <TableCell>{i + 1}</TableCell>
                    <TableCell>
                        <NumberFormat value={findHourValue(i)} customInput={TextField} thousandSeparator decimalScale={3} type='text'
                            onValueChange={(e) => handleHourValueChange(e, i)} disabled={false} fixedDecimalScale={true} />
                    </TableCell>
                </TableRow>
            ))
        }
        return rows;
    }

    const saveSchedules = () => {
        let date = moment(startDate);
        const finalSchedules = [];
        let tempSchedules = schedules;
        if (tempSchedules) {
            while (date.isSameOrBefore(moment(endDate), 'day')) {
                for (let schedule of tempSchedules) {
                    schedule.hourBeginningDateTime.hourBeginningDate = date.format("YYYY-MM-DD");
                }
                finalSchedules.push(...JSON.parse(JSON.stringify(tempSchedules)));
                date = date.add(1, 'days');
            }
        }
        if (props.onSave) {
            props.onSave(finalSchedules);
        }
    }

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={1} />
                <Grid item xs={6} sm={2}>
                    <FormControlLabel control={<Checkbox checked={isMultiDaySchedule} onChange={handleMultiDayScheduleChange} />} label="Multi-Day Schedule" />
                </Grid>
                <Grid item xs={6} sm={1} />
                <Grid item xs={6} sm={2}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" label="Start Date" name="startDate"
                            onChange={(date) => startDateChangeHandler(date)} value={startDate} fullWidth
                            autoOk={true} />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6} sm={1} />
                {isMultiDaySchedule ? (
                    <React.Fragment>
                        <Grid item xs={6} sm={2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" label="End Date" name="endDate"
                                    onChange={(date) => endDateChangeHandler(date)} value={endDate} fullWidth
                                    autoOk={true} minDate={startDate ? startDate : null} />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6} sm={3} />
                    </React.Fragment>
                ) : (
                    <Grid item xs={6} sm={5} />
                )}
            </Grid>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Hour Beginning</TableCell>
                            <TableCell>Hour Ending</TableCell>
                            <TableCell>MWhs</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderTableRows()}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Button onClick={saveSchedules}>Save</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
        </React.Fragment>
    )

}

export default CreateScheduleComponent;